<template>
  <view-page
      baseRoute="facilities.distribution-lists"
      entity="Distribution List"
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :model-id="$route.params.distributionListId"
  >
    <template v-slot="{model}">
      <distribution-list-form
          :readonly="readonly"
          v-model="model"
          ref="form"
          :loading="loading"
      />
    </template>
  </view-page>
</template>

<script>

import DistributionListForm from '@/views/pages/facilities/distribution-lists/DistributionListForm';
import ViewPage from "@/views/components/Views/ViewPage";

export default {
  name: "DistributionListEdit",
  components: {
    DistributionListForm,
    ViewPage,
  },
  data() {
    return {
      readonly: true,
      loading: false,
      modelEntity: this.$api.facilities.distributionLists,
      entity: 'Distribution List',
      componentAccess: {
        canEdit: {
          route: 'facilities.distribution-lists.edit',
          access: false,
        },
        canDelete: {
          route: 'facilities.distribution-lists.delete',
          access: false,
        },
      }
    };
  },
};
</script>
